import { SelectOption } from '~/shared/utils/types';

export const AUTOSCALING_STATE_PARAM_KEY = 'autoscaling_state';

export const autoscaleToAutoscalingFilterMap: Record<string, SelectOption | null> = {
  as_state_on: { id: 'on', name: 'On', group: 'autoscalingState' },
  as_state_off: { id: 'off', name: 'Off', group: 'autoscalingState' },
  as_state_unsupported: { id: 'not_supported', name: 'Unsupported', group: 'autoscalingState' },
};

export type FilterStoredInURL = Omit<SelectOption, 'group'> & {
  group: SelectOption['group'];
};

export function createAutoscalingFilters(pendingAutoscaleState: string[]): SelectOption[] {
  const mapped = pendingAutoscaleState
    .map((state) => autoscaleToAutoscalingFilterMap[state])
    .filter((f): f is SelectOption => f !== null);

  if (mapped.length === 0) {
    return [];
  }

  const hasOn = mapped.some((m) => m.id === 'on');
  const hasOff = mapped.some((m) => m.id === 'off');

  // Collapse on+off into one synthetic filter so getApiFilters emits {field: 'autoscalingState', value: 'on,off', op: 'equals'}
  if (hasOn && hasOff) {
    const others = mapped.filter((m) => m.id !== 'on' && m.id !== 'off');
    return [...others, { id: 'on,off', name: 'on,off', group: 'autoscalingState' }];
  }

  return mapped;
}

export function filterNonSpecificGroups(filters: FilterStoredInURL[]): SelectOption[] {
  return filters.filter((f) => {
    const isTagGroup = typeof f.group === 'string' && f.group.startsWith('tag:');
    return (
      f.group !== 'volumeId' &&
      f.group !== 'instanceId' &&
      f.group !== 'clusterName' &&
      f.group !== 'autoscalingState' &&
      !isTagGroup
    );
  });
}

export function combineFilters(
  baseApiFilters: SelectOption[],
  pendingClusterNameFilters: SelectOption[],
  pendingVolumeIdFilters: SelectOption[],
  pendingVolumeTagFilters: SelectOption[],
  pendingInstanceFilters: SelectOption[],
  autoscalingFilters: SelectOption[]
): SelectOption[] {
  return [
    ...baseApiFilters,
    ...pendingClusterNameFilters,
    ...pendingVolumeIdFilters,
    ...pendingVolumeTagFilters,
    ...pendingInstanceFilters,
    ...autoscalingFilters,
  ];
}
